import React from "react";
import { Card, Button } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars-2";
import { formatDate } from "../utils/dateUtils";

export const PrescriptionSummary = ({
	t,
	selectedPatient,
	recentPrescriptions,
	onClose,
	onSelectPrescription,
	isHospitalConnected,
	customerType,
	prescriptionDetails
}) => {

	return (
		<Card className="mb-3 prescriptions-card">
			<Card.Header
				style={{ position: "relative", padding: "10px 15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
			>
				<h6 style={{ margin: 0, fontWeight: 600 }}>
					{isHospitalConnected && customerType === "hospital_patient"
						? `${t("Top 5 Recent Prescriptions for")} ${selectedPatient?.full_name}`
						: `${t("Last 5 Sales for")} ${selectedPatient?.patient_name || selectedPatient?.full_name
						}`}
				</h6>

				<Button
					variant="link"
					className="p-0"
					style={{ fontSize: "1.2rem", lineHeight: 1, color: "#333" }}
					onClick={onClose}
					aria-label={t("Close prescriptions card")}
				>
					&times;
				</Button>
			</Card.Header>
			<Card.Body>
				<Scrollbars
					autoHide
					style={{ height: `150px` }}
					universal
					renderTrackHorizontal={(props) => <div {...props} style={{ display: "none" }} />}
				>
					{recentPrescriptions.map((prescription, index) => {
						let itemCount = 0;
						let medsList = [];

						if (isHospitalConnected && customerType === "inpatient") {
							itemCount = prescription.prescriptions?.length || prescription.items?.length;
							const rawItems = prescription.prescriptions || prescription.items || [];
							medsList =
								rawItems?.slice(0, 2).map((item) => {
									return item.medication_name ? item.medication_name + " " + item.salt_composition : item.brandName + " " + item.medicineName || item.salt_composition || t("Unknown Medicine");
								}) || [];

						}
						return (
							<div
								key={prescription._id}
								className="border-bottom prescription-item"
								onClick={() => onSelectPrescription(prescription || prescriptionDetails.prescriptions)}
								style={{ cursor: "pointer" }}
							>
								<strong>
									{t("Date")}: {formatDate(prescriptionDetails.createdAt || prescription.createdAt)}
								</strong>
								<p className="mb-0 mt-1 ms-2 text-muted small">
									{isHospitalConnected && customerType === "hospital_patient"
										? `${t("Consulted by")}: ${prescriptionDetails.doctor?.name || recentPrescriptions[0].doctor?.name || "N/A"
										}`
										: `${t("Items")}: ${itemCount}`}
								</p>
								{isHospitalConnected && customerType === "inpatient" &&
									medsList.map((med, i) => (
										<li className="tw-text-dark" key={i} style={{ lineHeight: "1.2em" }}>
											{med}
										</li>
									))
								}
							</div>
						)
					}
					)}
				</Scrollbars>
			</Card.Body>
		</Card>
	);
};

export default PrescriptionSummary;

